import { render, staticRenderFns } from "./m_reorder.vue?vue&type=template&id=6497b105&scoped=true&"
import script from "./m_reorder.vue?vue&type=script&lang=js&"
export * from "./m_reorder.vue?vue&type=script&lang=js&"
import style0 from "./m_reorder.vue?vue&type=style&index=0&id=6497b105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497b105",
  null
  
)

export default component.exports